<template>
  <div
    class="position-relative"
    @mouseenter="scoreHovered = true"
    @mouseleave="scoreHovered = false"
  >
    <router-link
      class="d-flex justify-center align-center score-meter"
      :to="disableLink ? '' : { name: 'editor-view', params: { id } }"
      @click.stop
    >
      <ScoreMeter
        :score="score"
        icon
        animate
      />
    </router-link>
    <v-icon
      v-if="scoreHovered && !disableLink"
      size="16"
      class="hover-icon"
      icon="material-symbols-light:edit-square-outline"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ScoreMeter from '@/components/editor/ScoreMeter.vue';

defineProps({
  score: { type: [Number, String], required: true },
  id: { type: [String, Number], required: true },
  disableLink: { type: Boolean, default: false },
});
const scoreHovered = ref(false);
</script>

<style lang="less" scoped>
.hover-icon {
  position: absolute;
  bottom: -2px;
  right: -12px;
  color: fade(@grey-900, 75%);
}

.score-meter {
  width: 40px;
  height: 40px;
}
</style>
